var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 90,
    viewBox: "0 0 96 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 78.75a2.81 2.81 0 0 0-2.813 2.813v5.624A2.81 2.81 0 0 0 48 90a2.81 2.81 0 0 0 2.812-2.813v-5.624A2.81 2.81 0 0 0 48 78.75z",
    fill: "#CFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.812 87.188v-5.626A2.81 2.81 0 0 0 48 78.75V90a2.81 2.81 0 0 0 2.812-2.813z",
    fill: "#A3C6CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 70.313H33.937c0 7.753 6.307 14.062 14.063 14.062s14.062-6.309 14.062-14.063H48z",
    fill: "#E6F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.062 70.313H48v14.062c7.756 0 14.062-6.309 14.062-14.063z",
    fill: "#CFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 0C30.913 0 17.062 13.851 17.062 30.938c0 12.017 6.866 22.41 16.875 27.533v11.842h28.125V58.47c10.01-5.124 16.875-15.517 16.875-27.533C78.937 13.85 65.087 0 48 0z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.062 58.47c10.01-5.123 16.875-15.516 16.875-27.532C78.937 13.85 65.087 0 48 0v70.313h14.062V58.47z",
    fill: "#FFD24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 33.75H2.812A2.81 2.81 0 0 1 0 30.937a2.81 2.81 0 0 1 2.812-2.812h5.813a2.81 2.81 0 0 1 2.812 2.813 2.81 2.81 0 0 1-2.812 2.812z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.187 33.75h-5.812a2.81 2.81 0 0 1-2.813-2.813 2.81 2.81 0 0 1 2.813-2.812h5.812A2.81 2.81 0 0 1 96 30.938a2.81 2.81 0 0 1-2.813 2.812z",
    fill: "#FFD24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.598 54.844A2.81 2.81 0 0 1 7.625 51l4.867-2.812c1.324-.775 3.06-.322 3.84 1.03a2.81 2.81 0 0 1-1.028 3.842l-4.866 2.813a2.812 2.812 0 0 1-3.84-1.03z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.668 12.656a2.81 2.81 0 0 1 1.027-3.842L85.562 6a2.81 2.81 0 0 1 3.84 1.03 2.81 2.81 0 0 1-1.027 3.843l-4.868 2.812a2.812 2.812 0 0 1-3.84-1.03z",
    fill: "#FFD24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.492 13.686-4.867-2.812A2.81 2.81 0 0 1 6.598 7.03a2.816 2.816 0 0 1 3.84-1.03l4.866 2.813a2.81 2.81 0 0 1 1.028 3.842 2.811 2.811 0 0 1-3.84 1.03z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.562 55.874-4.867-2.813a2.81 2.81 0 0 1-1.027-3.842 2.82 2.82 0 0 1 3.84-1.03L88.374 51a2.81 2.81 0 0 1 1.027 3.843 2.811 2.811 0 0 1-3.84 1.03zM62.277 27.683a2.814 2.814 0 0 0-2.27-1.915l-6.613-.96-2.96-5.994c-.459-.932-1.44-1.392-2.434-1.42-1.055-.03-2.123.43-2.61 1.42l-2.96 5.993-6.614.962a2.808 2.808 0 0 0-1.555 4.796l4.785 4.665-1.131 6.587a2.807 2.807 0 0 0 1.12 2.75 2.809 2.809 0 0 0 2.961.213L48 41.717l5.828 3.063a2.804 2.804 0 0 0 2.96-.214 2.807 2.807 0 0 0 1.121-2.75l-1.131-6.586 4.784-4.666a2.808 2.808 0 0 0 .715-2.881z",
    fill: "#FFD24D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.789 44.566a2.807 2.807 0 0 0 1.12-2.75l-1.131-6.586 4.784-4.666a2.809 2.809 0 0 0-1.554-4.796l-6.614-.96-2.96-5.994c-.459-.932-1.44-1.392-2.434-1.42v24.324l5.828 3.062a2.805 2.805 0 0 0 2.96-.214z",
    fill: "#FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.875 67.5h-33.75a2.81 2.81 0 0 0-2.813 2.813 2.81 2.81 0 0 0 2.813 2.812h33.75a2.81 2.81 0 0 0 2.812-2.813 2.81 2.81 0 0 0-2.812-2.812z",
    fill: "#CFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.687 70.313a2.81 2.81 0 0 0-2.812-2.813H48v5.625h16.875a2.81 2.81 0 0 0 2.812-2.813z",
    fill: "#A3C6CC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspire);
export default __webpack_public_path__ + "static/media/inspire.0de146b637d8a6b77e9f7101fd4b48fe.svg";
export { ForwardRef as ReactComponent };